import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/users/:userId/email-signature`;

export type GetEmailSignatureResponse = {
  emailSignature: string;
};

export const getEmailSignature = ({ userId }): Promise<GetEmailSignatureResponse> => {
  const URL = generateRoutePath(url, { userId });
  return axios.get(URL);
};

export const emailSignatureKeys = ({ userId }) => ['email-signature', userId];

type QueryFnType = typeof getEmailSignature;

type useEmailSignatureOptions = {
  userId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetEmailSignature = ({ config, ...otherParams }: useEmailSignatureOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: emailSignatureKeys(otherParams),
    queryFn: () => getEmailSignature(otherParams),
    staleTime: Infinity,
    ...config,
  });
};
